import React, { useEffect, useState } from 'react';
import _debounce from 'lodash/debounce';

import styles from './Places.module.css';
import { Button, TextInput } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import svg from './Search.svg';
import PlusSvg from '@icons/Plus.svg';
import PlacesTable from './PlacesTable';

import { useDisclosure } from '@mantine/hooks';
import { Modal } from '@mantine/core';
import ModalForm from './ModalForm';
import usePlaces from './hooks/usePlaces';
import { useNavigate, useSearchParams } from 'react-router-dom';

const Places = () => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [opened, { open, close }] = useDisclosure(false);
  const navigate = useNavigate();
  const [{ places, sortValue, sortName }, { fetchPlaces, createClaim, filterPlaces, sort, setSearch: setHookSearch }] = usePlaces(t, navigate, searchParams);

  let searchInit = '';
  let queryName = '';
  let queryValue = undefined;

  for (const entry of searchParams.entries()) {
    const [param, value] = entry;
    
    if (param === 'search') {
      searchInit = value
    }

    if (param === 'sortValue') {
      queryValue = Number(value)
    }

    if (param === 'sortName') {
      queryName = value
    }
  }

  const [search, setSearch] = useState(searchInit);
  const [debouceSearch, setDebounceSearch] = useState(searchInit);

  useEffect(() => {
    loadPlaces();
  }, [])

  useEffect(() => {
    filterPlaces(debouceSearch)
  }, [debouceSearch, places])

  const loadPlaces = async () => {
    setLoading(true);
    fetchPlaces().then(() => setLoading(false))
  }

  const handleChange = e => {
    const value = e.target.value;
    setDebounceSearch(value);
    setHookSearch(value);

    const queryValueString = queryValue ? `sortValue=${queryValue}` : '';
    const queryNameString = queryName ? `sortName=${queryName}` : '';
    const searchString = value ? `search=${value}` : '';
    const queryString = [queryValueString, queryNameString, searchString]
      .filter(a => !!a)
      .join('&');

    navigate(`/places/${!!queryString ? '?' : ''}${queryString}`, { replace: true })
  }

  const handleChangeDebounced = e => {
    setSearch(e.target.value)
    _debounce(() => handleChange(e), 200)()
  }

  const icon = <img src={svg} />

  return (
    <div className={styles.wrapper}>
      <div className={styles.top}>
        <div className={styles.title}>
          {t('places.title')}
        </div>

        <Button
          className={styles.button}
          leftSection={<img src={PlusSvg} />}
          onClick={open}
        >
          {t('places.button.add')}
        </Button>
      </div>

      <div className={styles.searchWrapper}>
        <TextInput
          leftSection={icon}
          className={styles.search}
          placeholder={t('search')}
          value={search}
          onChange={handleChangeDebounced}
        />
      </div>

      <div className={styles.tableWrapper}>
        <PlacesTable
          places={places}
          isLoading={loading}
          sortName={sortName}
          search={search}
          sortValue={sortValue}
          sort={sort}
        />
      </div>

      <Modal
        opened={opened}
        style={{ width: '428px' }}
        onClose={close}
        title={t('places.modalAdd.title')}
        centered
        className={styles.modal}
      >
        <ModalForm
          createClaim={createClaim}
          onClose={close}
        />
      </Modal>
    </div>
  )
}

export default Places;
